import { zipUrlStore as store } from "../utils/storage/index.js";
import {
  getDefaultHtml,
  getDefaultScript,
  getDefaultStyle,
  getHtmlLoader,
  getScriptLoader,
  getStyleLoader
} from "./config.js";
async function getScript() {
  return store.get("script") ?? await getDefaultScript();
}
function setScript(value) {
  store.set("script", value);
}
async function getTransformedScript() {
  const loader = getScriptLoader();
  const script = await getScript();
  return loader(script);
}
async function getHtml() {
  return store.get("html") ?? await getDefaultHtml();
}
async function getTransformedHtml() {
  const loader = getHtmlLoader();
  const html = await getHtml();
  return loader(html);
}
function setHtml(value) {
  store.set("html", value);
}
async function getStyle() {
  return store.get("style") ?? await getDefaultStyle();
}
function setStyle(value) {
  store.set("style", value);
}
async function getTransformedStyle() {
  const loader = getStyleLoader();
  const style = await getStyle();
  return loader(style);
}
export {
  getHtml,
  getScript,
  getStyle,
  getTransformedHtml,
  getTransformedScript,
  getTransformedStyle,
  setHtml,
  setScript,
  setStyle
};
//# sourceMappingURL=content.js.map
